module.exports = __webpack_public_path__ + "static/media/icon-arrow.612b3859.svg";